import { PropsWithChildren } from 'react';
import { GradientBox } from '@shared/components';

const PublicLayout = ({ children }: PropsWithChildren) => {
  return <GradientBox>{children}</GradientBox>;
};

export default PublicLayout;
